module.exports = __webpack_public_path__ + "img/moka-icon-w-text.cdc8f715.png";